<footer class="footer footer-static footer-light navbar-shadow">
    <p class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2">
        <span class="float-md-left d-block d-md-inline-block">
            Copyright &copy; 2021
            <a class="text-bold-800 grey darken-2" href="https://oxibit.com" target="_blank">Oxibit Technologies</a>
        </span>
        <span class="float-md-right d-none d-lg-block">
            <!-- Hand-crafted & Made with <i class="feather icon-heart pink"></i> -->
        </span>
    </p>
</footer>